import React from 'react'
import PropTypes from 'prop-types'
import Button, { TYPES } from '../../Button/index'
import { requestAnimationFrame } from '../../../services/animate/index'

function AccountCancelButtons (props) {
  const {
    previousUrl,
    previousText,
    previousHidden,
    nextUrl,
    nextText,
    nextType,
    nextClass,
    nextOnClick,
    nextDisabled,
  } = props

  const onClickGoBack = () => {
    if (window.scrollTo) {
      requestAnimationFrame(() => window.scrollTo(0, 0))
    }
  }

  return (
    <div className="account-cancel-buttons">
      {
        !previousHidden && <Button
          url={previousUrl}
          type={TYPES.SECONDARY}
          className="account-cancel-buttons__previous"
          onClick={onClickGoBack}
        >
          {previousText}
        </Button>
      }
      {
        <Button
            disabled={nextDisabled}
            type={nextType}
            className={`account-cancel-buttons__next ${nextClass}`}
            onClick={nextOnClick}
            url={nextUrl}
            submit
          >
          {nextText}
        </Button>
      }
    </div>
  )
}

AccountCancelButtons.defaultProps = {
  nextType: TYPES.PRIMARY,
  previousHidden: false,
}

AccountCancelButtons.propTypes = {
  previousUrl: PropTypes.string,
  nextUrl: PropTypes.string.isRequired,
  previousText: PropTypes.string,
  nextText: PropTypes.string.isRequired,
  nextDisabled: PropTypes.bool.isRequired,
  nextOnClick: PropTypes.func,
  nextType: PropTypes.string,
  nextClass: PropTypes.string,
}

export default AccountCancelButtons
